export default "__VITE_ASSET__DZWXDsH9__"